<template>
  <div class="serveDetail">
    <navigation></navigation>
    <div style="width:100%;height:90px;"></div>

    <!-- 面包屑导航 -->
    <div style="width:1200px;margin:0 auto;">
        <div class="crumbs">
          <span>当前位置：</span>
          <span @click="toHome">首页 ></span>
          <span @click="toExpert">专家库 ></span>
          <span @click="toExpertDetail">专家详情</span>
        </div>
    </div>

    <div class="head">
      <img :src="data.remarkImg" />
      <div class="text">
        <div class="text-b">{{data.realName}}</div>
        <div class="text-s">
          <span>
            职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;务：
            <span>{{data.dutiesName}}</span>
          </span>
          <span>
            职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：
            <span>{{data.positionName}}</span>
          </span>
          <span>
            行&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业：
            <span>{{data.industryName}}</span>
          </span>
          <span>
            指导项目：
            <span>{{data.projectNum}}个</span>
          </span>
          <span>
            指导学员：
            <span>{{data.studentNum}}人</span>
          </span>
        </div>
        <div style="clear: both; height: 26px"></div>
        <button class="zixunbtn"><span class="zixunspan"></span>咨询</button>
      </div>
    </div>
    <div class="serveDetails">
      <div class="blueLine"></div>
      <div class="serveDetailsCH">专家详情</div>
      <div class="serveDetailsEN">Expert details</div>
      <div class="article" v-html="data.remark" ref="remark">{{data.remark}}</div>
      <div style="clear:both;"></div>
    </div>
    <div style="width:100%;height:100px;"></div>
  </div>
</template>

<script>
// import helloworld from '@/components/helloworld.vue' //引入组件
import navigation from "@/components/common/navigation"

export default {
    name: "expertDetail",
    components: {
      navigation
    },
    data() {
      return {
        data:{},
      };
    },
    methods: {
      toHome(){
        sessionStorage.setItem('tabIndex',1);
        this.$router.push("/");
      },
      toExpert() {
        this.$router.push("/Expert");
      },
      toExpertDetail() {
        this.$router.push("/expertDetail");
      },
      outoHeightFn(){ 
          setTimeout(() => {
              let dom = this.$refs.remark;
              const height = this.$refs.remark.offsetHeight;
              if(height < 300){
                  dom.style.height = '300px';
              }
          }, 300);
      },  
    },
    created(){
        let expertId = this.$route.query.id;
        // 地区名列表  
        this.$axios.post("/v1/cloud/common/expert/details",{
            expertId,
        }
        ).then(({data})=>{
            if(data){
                this.data = data;
            }
        }).catch(error=>{
            this.$message({
                message: error.response.data.message,
                type: 'warning'
            });
        })
    },
    mounted(){
      //滚动条从顶部开始
      let osTop = document.documentElement.scrollTop || document.body.scrollTop;
      if(osTop > 0){
          document.documentElement.scrollTop = document.body.scrollTop = 0;
      }
      //内容详情高度样式适配

    }
};
</script>

<style scoped lang="less">
.serveDetail {
  width: 100%;
  // height: 1300px;
  // height:auto;s
  // overflow: hidden;
  // position: relative;
    .zixunspan {
    width: 18px;
    height: 14px;
    display: inline-block;
    background-image: url("../../static/server/zixunicon.png");
    background-size: 18px 14px;
    vertical-align: middle;
    margin-right: 9px;
  }
  button {
    width: 140px;
    height: 40px;
    border: 1px solid #3476c1;
    background-color: #fff;
    font-style: 16px;
    font-family: MicrosoftYaHei;
    outline: none;
    font-weight: 400;
    // margin-top: 15px;
    margin-right: 30px;
    color: #3476c1;
    border-radius: 3px;
    cursor: pointer;
  }
  button.ljbmbtn {
    background-color: #3476c1;
    color: #fff;
  }
  background-color: #f5f5f5;
  .crumbs {
    width: 310px;
    height: 12px;
    // position: absolute;
    // top: -60px;
    // left: 960px;
    float: left;
    margin-top: 20px;
    font-family: MicrosoftYaHei;
    span {
      float: left;
      font-style: 12px;
      cursor: pointer;
      margin-left: 5px;
      color: #666666;
    }
    span:nth-child(4) {
      color: #333333;
    }
    // span:nth-child(3){
    //     margin-left: 10px;
    // }
  }
  .head {
    width: 1200px;
    height: 340px;
    margin: 60px auto 0;
    padding: 20px;
    background-color: #fff;
    box-sizing: border-box;
    img {
      width: 470px;
      height: 300px;
      float: left;
    }
    .text {
      width: 660px;
      float: right;
      margin-left: 30px;
      padding-top: 14px;
      .text-b {
        font-size: 24px;
        line-height: 24px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: #333333;
        margin-bottom: 9px;
      }
      .text-s {
        // width: 700px;
        > span {
          display: block;
          font-size: 16px;
          color: #999999;
          line-height: 36px;
          span {
            color: #333333;
          }
          // .money{
          //     font-size: 24px;
          //     color: #FD6114;
          // }
        }
      }
    }
  }
  .serveDetails {
    // height: 1000px;
    height: auto;
    width: 1200px;
    margin: 20px auto 0;
    // margin-top: 50px;
    padding: 20px;
    padding-top: 30px;
    background-color: #fff;
    .blueLine {
      width: 3px;
      height: 20px;
      background: rgba(15, 155, 241, 1);
      float: left;
      margin-top: 5px;
    }
    .serveDetailsCH {
      float: left;
      // width:78px;
      // height:19px;
      font-size: 20px;
      font-family: MicrosoftYaHei;
      font-weight: 500;
      color: #333333;
      margin-left: 10px;
    }
    .serveDetailsEN {
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #999999;
      float: left;
      margin-left: 10px;
      margin-top: 7px;
    }
    .article {
      width: 100%;
      float: left;
      font-style: 16px;
      margin-top: 25px;
      font-family: MicrosoftYaHei;
      text-align: justify;
      padding-left: 10px;
    }
  }
}
</style>